import axios from 'axios';
import { ssoLogoutUrl } from './sso';
const api = import.meta.env.VITE_APP_API;


class AuthService {
   async funLogin(user, endpoint = 'Account/Login') {
        return axios.post(api + endpoint, user).then((res) => {
            if (res.data) {
                const currentDate = new Date();
                const expireTokenTime = new Date(currentDate.getTime() + 59 * 60 * 1000).toString();
                const jToken = { ExpireToken: expireTokenTime, token: res.data.token, refresh_token: res.data.refresh_token }
                localStorage.setItem('user', JSON.stringify(res.data));
                localStorage.setItem('token', JSON.stringify(jToken));
            }
            return res.data;
        });
    }

    async funLoginKeycloak(accessToken, idToken) {
        const data = await this.funLogin({ accessToken }, 'Account/LoginKeycloak');
        if (idToken) localStorage.setItem('sso_id_token', idToken);
        return data;
    }

    async funnLogout(skipSso = false) {
        // Backend không có endpoint Account/Logout: chỉ cần xóa phiên ở trình duyệt.
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        const idToken = localStorage.getItem('sso_id_token');
        localStorage.removeItem('sso_id_token');
        if (idToken && !skipSso) {
            window.location.href = ssoLogoutUrl(idToken);
        }
    }

   async funRigister(user) {
        return axios.post(api + 'Account/Register', user).then((res) => {
            return res.data;
        });
    }
   async funForgotPassword(email) {
        return axios.post(api + 'Account/send-reset-password-otp', { email }).then((res) => {
            return res;
        });
    }
    async funConfirmOTP(email, otp) {
        return axios.post(api + 'Account/verify-reset-password-otp', { email, otp }).then((res) => {
            return res;
        });
    }
    async funResetPassword(email, newPassword) {
        return axios.post(api + 'Account/reset-password', { ...email, newPassword: newPassword }).then((res) => {
            return res;
        });
    }
}

export default new AuthService();
